export const ColourField = ({ raw, options, value, onChange }) => {
  if (!raw) return null;
  if (options.length > 1) return <OptionPicker label="Colour" options={options} value={value} onChange={onChange} testid="colour" />;
  return (
    <div data-testid="colour-field">
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#71717A] mb-2">Colours available · <span className="text-[#0F0F0F] normal-case tracking-normal font-sans text-sm">{raw}</span></p>
      <input
        data-testid="colour-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Your preferred colour (optional)"
        className="w-full max-w-sm bg-transparent border-b border-[#0F0F0F]/25 focus:border-[#C5A059] outline-none py-2 text-sm"
      />
    </div>
  );
};

export const OptionPicker = ({ label, options, value, onChange, testid }) => {
  if (!options.length) return null;
  return (
    <div data-testid={`${testid}-picker`}>
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#71717A] mb-3">
        {label}{value && <span className="text-[#0F0F0F]"> · {value}</span>}
      </p>
      <div className="flex flex-wrap gap-2">
        {options.map((o) => (
          <button
            key={o}
            type="button"
            data-testid={`${testid}-option-${o.toLowerCase().replace(/\s+/g, "-")}`}
            onClick={() => onChange(o)}
            className={`min-w-[48px] px-4 py-2 text-sm border transition-colors ${value === o ? "border-[#0F0F0F] bg-[#0F0F0F] text-[#C5A059]" : "border-[#0F0F0F]/20 hover:border-[#0F0F0F]"}`}
          >
            {o}
          </button>
        ))}
      </div>
    </div>
  );
};
